/* unplugin-vue-components disabled */import { render } from "./navbar-item.vue?vue&type=template&id=c72e7e7e&scoped=true"
import script from "./navbar-item.vue?vue&type=script&lang=js"
export * from "./navbar-item.vue?vue&type=script&lang=js"

import "./navbar-item.vue?vue&type=style&index=0&id=c72e7e7e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72e7e7e"],['__file',"src/components/navbar/navbar-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c72e7e7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c72e7e7e', __exports__)) {
    api.reload('c72e7e7e', __exports__)
  }
  
  module.hot.accept("./navbar-item.vue?vue&type=template&id=c72e7e7e&scoped=true", () => {
    api.rerender('c72e7e7e', render)
  })

}


export default __exports__